<template>
    <VJoyAvatar
        size="small"
        :full-name="freelancerIdentity?.fullName"
        :photo-url="freelancerPhoto"
        :color="freelancerPhoto ? 'transparent' : 'secondary'"
        class="navbar-freelancer-avatar"
        :class="{'navbar-freelancer-avatar--text': !freelancerPhoto}"
    />
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyAvatar} from '@maltjoy/core-vue';
    import {useUserStore} from '../../user';

    const {avatarSize = '18px'} = defineProps<{
        avatarSize?: string;
    }>();

    const userStore = useUserStore();
    const {userIdentities} = storeToRefs(userStore);

    const freelancerIdentity = userIdentities.value.find((identity) => {
        return identity.type === 'FREELANCE';
    });
    const freelancerPhoto = computed(() => {
        return freelancerIdentity?.photo ? `${freelancerIdentity.photo?.baseUrl}/${freelancerIdentity.photo?.name}?func=crop&w=30&h=30` : undefined;
    });
</script>
<style lang="scss">
    .navbar-freelancer-avatar {
        --avatar-size: v-bind(avatarSize) !important;
        width: v-bind(avatarSize);
        height: v-bind(avatarSize);
        font-size: var(--joy-font-size-primary-800);
        flex: 0 0 auto;

        &--text {
            font-size: unset;
        }
    }
</style>
